import { ExclamationCircleOutlined } from '@ant-design/icons';
import { observer } from 'mobx-react';
import React from 'react';
import styled from 'styled-components';

import type Bundle from 'stores/Bundle';
import { DocumentStatus } from 'types/DocumentStatus';

const ExclamationCircleIcon = styled(ExclamationCircleOutlined)`
  align-self: center;
  color: red;
  padding-right: 12px;
`;

export interface BundleWarningIconProps {
  bundle: Bundle;
}

function BundleWarningIcon({ bundle }: BundleWarningIconProps) {
  return bundle.warning || bundle.status === DocumentStatus.ERROR ? (
    <ExclamationCircleIcon />
  ) : null;
}

export default observer(BundleWarningIcon);
